<script setup>
import { useElementSize } from '@vueuse/core';
import { ref, computed, onMounted, nextTick } from 'vue';

const container = ref();
const width = ref();

onMounted(async () => {
  await nextTick();
  width.value = container.value[0].getBoundingClientRect().width;
});
</script>

<template>
  <vs-tabs
    v-model="activeTab"
    class="flex-1 h-full flex flex-col w-full overflow-hidden"
  >
    <vs-tab
      v-for="tab in component"
      :key="tab.label"
      :label="tab.label"
      :icon="tab.icon"
      @click="colorx = '#8B0000'"
      class="w-full overflow-hidden"
    >
      <!-- <reports-table
    v-if="component[activeTab].view.type == 'table'"
    :reportData="reportData"
    :currentTable="currentTable"
    :type="type"
    :activeTab="activeTab"
    :gridId="activeTab"
    :timeRange="timeRange"
    :reportsComponent="reportsComponent"

      /> -->
      <div class="w-full h-full overflow-hidden" ref="container">
        <component
          v-if="width"
          :is="`reports-${reportsComponent.view.type}`"
          :reportData="reportData"
          :currentTable="currentTable"
          :type="type"
          :activeTab="activeTab"
          :gridId="activeTab"
          :timeRange="timeRange"
          :reportsComponent="reportsComponent"
          :summarySeries="summarySeries"
          :style="{ width: `${width ? width - 10 : 10}px !important` }"
          :width="`${width ? width : 10}px`"
        />
      </div>
    </vs-tab>
    <!-- modal -->
    <Transition name="scale">
      <div
        v-if="pdfModal"
        class="fixed p-10 flex"
        style="
          left: 0;
          top: 0;
          height: 100vh;
          width: 100vw;
          z-index: 99999;
          backdrop-filter: blur(5px);
        "
        @click.self="pdfModal = false"
      >
        <div
          class="w-full h-full bg-black rounded-lg flex shadow-md overflow-hidden relative"
        >
          <slot
            :name="slotName"
            :data="{
              slotName,
              reportsContent,
              reportData,
              currentTable,
              units,
              type,
              activeTab,
              timeRange,
              reportsComponent,
            }"
          />

          <i
            @click="closeModalView"
            class="mr-4 mt-4 vs-icon notranslate icon-scale vs-popup--close vs-popup--close--icon material-icons null"
            style="
              background: rgb(255, 255, 255);
              position: absolute;
              right: 0;
              top: 0;
            "
            >close</i
          >
        </div>
      </div>
    </Transition>
  </vs-tabs>
</template>

<script>
import reportsTable from '../../components/reports-table/ReportsTable.vue';
import ReportsChart from '../../components/reports-chart/ReportsChart.vue';
import {
  GridPlugin,
  Sort,
  Group,
  Resize,
  Filter,
  Toolbar,
  Search,
  ExcelExport,
  ColumnChooser,
  PdfExport,
  Page,
  CommandColumn,
  VirtualScroll,
} from '@syncfusion/ej2-vue-grids';
import columntempVue from './reportLinkTemplate1.vue';
export default {
  components: {
    GridPlugin,
    columntempVue,
    reportsTable,
    ReportsChart,
  },
  provide: {
    grid: [
      Group,
      Sort,
      Filter,
      Toolbar,
      Resize,
      Search,
      ExcelExport,
      ColumnChooser,
      PdfExport,
      Page,
      CommandColumn,
      VirtualScroll,
    ],
  },
  props: {
    component: Array,
    reportsData: Array,
    timeRange: Array,
    units: Array,
    subAccountId: Number,
    assetNameArr: Array,
    type: String,
    showAnalysisButton: Boolean,
    summarySeries: Array,
  },
  computed: {
    reportsComponent() {
      return this.component[this.activeTab];
    },
    currentTable() {
      return this.component[this.activeTab].view.content;
    },
    reportData() {
      if (this.activeTab == 2 && this.type == 'POI - Watch') {
        return this.reportsData[4];
      }
      return this.reportsData[this.activeTab];
    },
  },
  data() {
    return {
      activeTab: 0,
      pdfModal: false,
      slotName: '',
      reportsContent: null,
    };
  },
  methods: {
    modalView(v, data) {
      this.slotName = v;
      this.pdfModal = true;
      this.$emit('setModalView', v, data);
    },
    closeModalView() {
      this.pdfModal = false;
    },
  },
  watch: {
    showAnalysisButton: {
      handler() {
        if (this.showAnalysisButton) {
          this.currentTable.forEach((e) => {
            if (e.hide) {
              e.hide = false;
            }
          });
        } else {
          this.currentTable.forEach((e) => {
            if (e.hide == false) {
              e.hide = true;
            }
          });
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.reportsContent = this;
    this.selectedFields = [];
    this.currentTable.forEach((e) => {
      if (e.field) {
        this.selectedFields.push(true);
      }
    });
  },
};
</script>
<style scoped>
.scale-enter-active,
.scale-leave-active {
  transition: all 0.5s ease;
}

.scale-enter-from,
.scale-leave-to {
  opacity: 0;
  transform: scale(0.9);
}
</style>
<style>
.scale-enter-active,
.scale-leave-active {
  transition: all 0.2s cubic-bezier(0.39, 0.575, 0.565, 1);
}

.scale-enter,
.scale-leave {
  opacity: 0;
  transform: scale(0.9);
}
.e-grid .e-excelexport {
  color: green;
  font-weight: bold;
}

.e-grid .e-pdfexport {
  color: red;
  font-weight: bold;
}
[dir] .e-grid .e-headercell,
[dir] .e-grid .e-detailheadercell {
  padding: 0 15px 0;
}
.e-headercelldiv {
  padding: 0 0em 0 0.4em;
}
/* .e-rowcell {
  vertical-align: top !important;
} */

.con-slot-tabs {
  display: flex !important;
  flex: 1 1 0%;
}

@import '../../../node_modules/@syncfusion/ej2-base/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-calendars/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-popups/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css';
</style>
